module.exports={
 "text": "No. 109 [No. 99(379), No. 110]\r\n佛說轉法輪經\r\n\r\n後漢安息三藏安世高譯\r\n聞如是：一時，佛在波羅㮈國鹿野樹下坐，時\r\n有千比丘諸天神，皆大會側塞空中，於是有\r\n自然法輪，飛來當佛前轉。佛以手撫輪曰：\r\n「止！往者吾從無數劫來，為名色轉受苦無\r\n量，今者癡愛之意已止，漏結之情已解，諸\r\n根已定生死已斷，不復轉於五道也。」輪即\r\n止。於是，佛告諸比丘：「世間有二事墮邊行，\r\n行道弟子捨家者，終身不當與從事。何等二？\r\n一為念在貪欲無清淨志，二為猗著身愛\r\n不能精進。是故退邊行，不得值佛道德具\r\n人。若此比丘不念貪欲著身愛行，可得受中，\r\n如來最正覺得眼得慧，從兩邊度自致泥洹。\r\n何謂受中？謂受八直之道，一曰正見，二曰\r\n正思，三曰正言，四曰正行，五曰正命，六曰\r\n正治，七曰正志，八曰正定。若諸比丘本末\r\n聞道，當已知甚苦為真諦，已一心受眼受禪\r\n思受慧見，覺所念令意解，當知甚苦習盡為\r\n真諦，已受眼觀禪思慧見，覺所念令意解，如\r\n是盡真諦。何謂為苦？謂生老苦、病苦，憂、悲、惱\r\n苦，怨憎會苦，所愛別苦，求不得苦，要從五陰\r\n受盛為苦。何謂苦習？謂從愛故而令復有樂\r\n性，不離在在貪憙，欲愛、色愛、不色之愛，是\r\n習為苦。何謂苦盡？謂覺從愛復有所樂，婬\r\n念不受，不念無餘無婬，捨之無復禪，如是\r\n為習盡。何謂苦習盡欲受道？謂受行八直\r\n\r\n道，正見、正思、正言、正行、正命、正治、正志、正定，\r\n是為苦習盡受道真諦也。\r\n「又是，比丘！苦為真諦，苦由習為真諦，苦習\r\n盡為真諦，苦習盡欲受道為真諦，若本在昔\r\n未聞是法者，當受眼觀禪行受慧見受覺念\r\n令意得解。若令在斯未聞是四諦法者，當受\r\n道眼、受禪思、受慧覺，令意行解。若諸在彼不\r\n得聞是四諦法者，亦當受眼、受禪、受慧、受覺，\r\n令意得解，是為四諦三轉合十二事，知而未\r\n淨者吾不與也。一切世間諸天人民，若梵、若\r\n魔、沙門、梵志，自知證已，受行戒、定、慧、解、度知\r\n見成，是為四極。是生後不復有，長離世間無\r\n復憂患。」佛說是時，賢者阿若拘鄰等及八\r\n千姟天，皆遠塵離垢諸法眼生。其千比丘\r\n漏盡意解，皆得阿羅漢，及上諸習法應當\r\n盡者一切皆轉。眾祐法輪聲三轉，諸天世間\r\n在法地者莫不遍聞，至于第一四天王、忉\r\n利天、焰天、兜術天、不驕樂天、化應聲天，至諸\r\n梵界須臾遍聞。爾時，佛界三千日月萬二千\r\n天地皆大震動，是為佛眾祐，始於波羅㮈以\r\n無上法輪轉未轉者，照無數度諸天人從是\r\n得道。佛說是已，皆大歡喜。\r\n佛說轉法輪經\r\n",
 "notes": {
  "nkr_note_orig_0503013_00": {
   "type": "rev",
   "s": 32,
   "l": 0,
   "t": "",
   "author": "宋"
  },
  "nkr_note_orig_0503013_01": {
   "type": "rev",
   "s": 32,
   "l": 0,
   "t": "",
   "author": "元"
  },
  "nkr_note_orig_0503013_02": {
   "type": "rev",
   "s": 32,
   "l": 0,
   "t": "",
   "author": "明"
  },
  "nkr_note_orig_0503014_00": {
   "type": "rev",
   "s": 42,
   "l": 6,
   "t": "後漢",
   "author": "宋"
  },
  "nkr_note_orig_0503014_01": {
   "type": "rev",
   "s": 42,
   "l": 6,
   "t": "後漢",
   "author": "元"
  },
  "nkr_note_orig_0503015_00": {
   "type": "rev",
   "s": 65,
   "l": 1,
   "t": "柰",
   "author": "明"
  },
  "nkr_note_orig_0503016_00": {
   "type": "rev",
   "s": 87,
   "l": 1,
   "t": "畟",
   "author": "元"
  },
  "nkr_note_orig_0503016_01": {
   "type": "rev",
   "s": 87,
   "l": 1,
   "t": "畟",
   "author": "明"
  },
  "nkr_note_orig_0503017_00": {
   "type": "rev",
   "s": 119,
   "l": 1,
   "t": "上",
   "author": "明"
  },
  "nkr_note_orig_0503018_00": {
   "type": "rev",
   "s": 134,
   "l": 1,
   "t": "更",
   "author": "宋"
  },
  "nkr_note_orig_0503018_01": {
   "type": "rev",
   "s": 134,
   "l": 1,
   "t": "更",
   "author": "元"
  },
  "nkr_note_orig_0503018_02": {
   "type": "rev",
   "s": 134,
   "l": 1,
   "t": "更",
   "author": "明"
  },
  "nkr_note_orig_0503019_00": {
   "type": "rev",
   "s": 181,
   "l": 1,
   "t": "上",
   "author": "元"
  },
  "nkr_note_orig_0503020_00": {
   "type": "rev",
   "s": 239,
   "l": 1,
   "t": "倚",
   "author": "明"
  },
  "nkr_note_orig_0503021_00": {
   "type": "rev",
   "s": 241,
   "l": 1,
   "t": "",
   "author": "宋"
  },
  "nkr_note_orig_0503021_01": {
   "type": "rev",
   "s": 241,
   "l": 1,
   "t": "",
   "author": "元"
  },
  "nkr_note_orig_0503021_02": {
   "type": "rev",
   "s": 241,
   "l": 1,
   "t": "",
   "author": "明"
  },
  "nkr_note_orig_0503022_00": {
   "type": "rev",
   "s": 262,
   "l": 1,
   "t": "真",
   "author": "宋"
  },
  "nkr_note_orig_0503022_01": {
   "type": "rev",
   "s": 262,
   "l": 1,
   "t": "真",
   "author": "元"
  },
  "nkr_note_orig_0503022_02": {
   "type": "rev",
   "s": 262,
   "l": 1,
   "t": "真",
   "author": "明"
  },
  "nkr_note_orig_0503023_00": {
   "type": "rev",
   "s": 357,
   "l": 1,
   "t": "念",
   "author": "宋"
  },
  "nkr_note_orig_0503023_01": {
   "type": "rev",
   "s": 357,
   "l": 1,
   "t": "念",
   "author": "元"
  },
  "nkr_note_orig_0503023_02": {
   "type": "rev",
   "s": 357,
   "l": 1,
   "t": "念",
   "author": "明"
  },
  "nkr_note_orig_0503024_00": {
   "type": "rev",
   "s": 369,
   "l": 1,
   "t": "未",
   "author": "元"
  },
  "nkr_note_orig_0503024_01": {
   "type": "rev",
   "s": 369,
   "l": 1,
   "t": "未",
   "author": "明"
  },
  "nkr_note_orig_0503025_00": {
   "type": "rev",
   "s": 409,
   "l": 1,
   "t": "集",
   "author": "元"
  },
  "nkr_note_orig_0503025_01": {
   "type": "rev",
   "s": 409,
   "l": 1,
   "t": "集",
   "author": "明"
  },
  "nkr_note_orig_0503026_00": {
   "type": "rev",
   "s": 551,
   "l": 1,
   "t": "愛",
   "author": "宋"
  },
  "nkr_note_orig_0503026_01": {
   "type": "rev",
   "s": 551,
   "l": 1,
   "t": "愛",
   "author": "元"
  },
  "nkr_note_orig_0503026_02": {
   "type": "rev",
   "s": 551,
   "l": 1,
   "t": "愛",
   "author": "明"
  },
  "nkr_note_orig_0503027_00": {
   "type": "rev",
   "s": 731,
   "l": 1,
   "t": "得",
   "author": "宋"
  },
  "nkr_note_orig_0503027_01": {
   "type": "rev",
   "s": 731,
   "l": 1,
   "t": "得",
   "author": "元"
  },
  "nkr_note_orig_0503027_02": {
   "type": "rev",
   "s": 731,
   "l": 1,
   "t": "得",
   "author": "明"
  },
  "nkr_note_orig_0503028_00": {
   "type": "rev",
   "s": 831,
   "l": 1,
   "t": "受",
   "author": "明"
  },
  "nkr_note_orig_0503029_00": {
   "type": "rev",
   "s": 878,
   "l": 1,
   "t": "十",
   "author": "宋"
  },
  "nkr_note_orig_0503029_01": {
   "type": "rev",
   "s": 878,
   "l": 1,
   "t": "十",
   "author": "元"
  },
  "nkr_note_orig_0503029_02": {
   "type": "rev",
   "s": 878,
   "l": 1,
   "t": "十",
   "author": "明"
  },
  "nkr_note_orig_0503030_00": {
   "type": "rev",
   "s": 905,
   "l": 1,
   "t": "",
   "author": "宋"
  },
  "nkr_note_orig_0503030_01": {
   "type": "rev",
   "s": 905,
   "l": 1,
   "t": "",
   "author": "元"
  },
  "nkr_note_orig_0503030_02": {
   "type": "rev",
   "s": 905,
   "l": 1,
   "t": "",
   "author": "明"
  },
  "nkr_note_orig_0503031_00": {
   "type": "rev",
   "s": 949,
   "l": 1,
   "t": "於",
   "author": "明"
  },
  "nkr_note_orig_0503032_00": {
   "type": "rev",
   "s": 963,
   "l": 0,
   "t": "摩",
   "author": "宋"
  },
  "nkr_note_orig_0503032_01": {
   "type": "rev",
   "s": 963,
   "l": 0,
   "t": "摩",
   "author": "元"
  },
  "nkr_note_orig_0503032_02": {
   "type": "rev",
   "s": 963,
   "l": 0,
   "t": "摩",
   "author": "明"
  },
  "nkr_note_orig_0503033_00": {
   "type": "rev",
   "s": 1021,
   "l": 1,
   "t": "捺",
   "author": "元"
  }
 },
 "versions": {
  "宋": 1,
  "元": 7,
  "明": 9
 }
}
